import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider } from '@chakra-ui/react'
import { BrowserRouter } from 'react-router-dom';
import { extendTheme } from "@chakra-ui/react";
const root = ReactDOM.createRoot(document.getElementById('root'));

    const customTheme = extendTheme({
      colors: {
        brand: {
          orange: "#FF9141",
          mildOrange: "#FFB482",// ...
          blue: "#000081"
        },
      },
    });
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <ChakraProvider theme={customTheme}>
        <App />
      </ChakraProvider>
    </React.StrictMode>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
